import { Helper } from "../util/helper.js";
import { HTTPService } from "../util/httpManager.js";
import { BaseDataSourceComponentProps, BaseDataSourceField } from "./baseComponentProps.js";
import { MultipleCheckBoxesProps } from "./multipleCheckBoxes.js";
import React from "react";
export class MultipleRadioButtons extends React.Component<MultipleRadioButtonsProps, any>{

    private icuh = Helper;
    private lastDatasourceUrl: string;

    constructor(props) {
        super(props);
        this.state = { buttons: [] };
    }

    private _handleChange = (value, dataItem) => {
        this.props.onChange(this.props.field, value, dataItem);
    }

    private processTemplate = (datasourceUrl: string): string => {
        try {
            if (this.dataSourceUrlHasTemplate(datasourceUrl)) {
                datasourceUrl = this.icuh.processTemplate(this.props.field.dataSourceUrl, ((match) => {
                    const result = this.props.handleEval(match);
                    if (Helper.hasValue(result)) {
                        return encodeURIComponent(result);
                    } else {
                        return "";
                    }
                }));
            }
        } catch (ex) {
            console.error("Could not process dataSourceUrl teplate. " + ex)
        }
        return datasourceUrl;
    }

    private dataSourceUrlHasTemplate = (datasourceUrl: string): boolean => {
        if (this.icuh.hasValue(this.props.field.dataSourceUrl) && this.props.field.dataSourceUrl.indexOf("{") != -1) {
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps: MultipleCheckBoxesProps) {
        if (this.dataSourceUrlHasTemplate(this.props.field.dataSourceUrl)) {
            const newUrl = this.processTemplate(this.props.field.dataSourceUrl);
            if (newUrl !== this.lastDatasourceUrl) {
                this.lastDatasourceUrl = newUrl;
                HTTPService.get(newUrl)
                    .then(data => {
                        this.setState({ buttons: data });
                        this.props.onDataLoaded(this.props.field, data);
                    }
                    );
            }
        }

        if (this.props.field.refreshDSOnRefChange && this.props.dataSource != prevProps.dataSource) {
            this.setState({ buttons: this.props.dataSource });
        }
    }

    componentDidMount() {
        if (Array.isArray(this.props.dataSource)) {
            this.setState({ buttons: this.props.dataSource });
        } else if (this.props.field.dataSourceUrl !== undefined && this.props.field.dataSourceUrl !== null && this.props.field.dataSourceUrl !== "") {
            let tmpUrl = this.props.field.dataSourceUrl;
            if (this.dataSourceUrlHasTemplate(tmpUrl)) {
                tmpUrl = this.processTemplate(tmpUrl);
            }

            HTTPService.get(tmpUrl)
                .then(data => {
                    this.setState({ buttons: data });
                    this.props.onDataLoaded(this.props.field, data);
                }
                );
        }
    }

    render() {
        let buttons = this.state.buttons.map((b, i) => {
            const id = `rb-${i}-${this.props.field.guid || this.props.field.name}`;
            return (
                <div key={i} style={{ margin: "2px 3px" }} >
                    <input type="radio" id={id} className="k-radio k-radio-md" onChange={(e) => this._handleChange(b[this.props.field.dataValueField], b)} name={this.props.field.model}
                        value={b[this.props.field.dataValueField]} checked={this.props.value === b[this.props.field.dataValueField]} disabled={this.props.disabled} required={this.props.required} data-label={this.props.field.name} />
                    <label htmlFor={id} className="k-radio-label" style={{ /*marginRight: "10px"*/ }}>{b[this.props.field.dataTextField]}</label>
                </div>
            );
        });

        return (
            <div className="multiple-radio-buttons__container">{buttons}</div>
        );
    }
};
export interface MultipleRadioButtonsProps extends BaseDataSourceComponentProps {
    field: MultipleRadioButtonsField;
    handleEval?(action: string, prepare?: any);
}

export interface MultipleRadioButtonsField extends BaseDataSourceField {
}